import React from "react";
import './OnePlatform.css'
import Button from "../button/Button";
import { images } from "../../assets";

function OnePlatform({buttonText, onButtonClick}) {
  return (
    <div className="onePlatform">

      <div className="onePlatformBox">
      <div className="platformLeft">
        <div className="platformText">
          <div className="platformTitle">
            <div>One platform.</div>
            <div>Multi Benefits.</div>
          </div>
          <div className="platformBenefit" >
            We deeply understand the intrinsic and extrinsic motivation and
            engagement drivers of people. That's why we built Impact - an
            integrated platform for companies to build a truly healthy & happy
            workforce.
          </div>
        </div>
        
        <div className="platformBtnWrap">
          <div className="iconGroup">
            <div className="competitionRow" >
            <div className="competition"> <img src={images.competition} alt="competition" /> Competition</div>
            <div className="competition"> <img src={images.competition}alt="Recognition" /> Recognition</div>
            </div>
            <div className="fitinessRow">
            <div className="competition"> <img src={images.man} alt="fitiness" /> Fitiness</div>
            <div className="competition"> <img src={images.hand} alt="kindness" /> Kindness</div>
            </div>
          </div>
        
        <Button onClick={onButtonClick} buttonText={buttonText} className="bookDemoButton" arrowClassName="custom-arrow" />
        </div>
        
      </div>
      <div className="platformContainer">
        <div className="platformRow1">
        <img id="box1" src={images.ready} alt="ready" />
        <img id="box2" src={images.clap} alt="clap" />
        </div>
        <div className="platformRow2">
        <img id="box3" src={images.exercise} alt="exercise" />
        <img id="box4" src={images.running} alt="running" />
        </div> 
      </div>
      </div>
      
    </div>
  );
}


export default OnePlatform;
